import { createFileRoute } from "@tanstack/react-router"
import { SocialMatchSubmittedPage } from "@/pages/social-match"

export const Route = createFileRoute("/_authenticated/social-match/submitted")({
	component: SocialMatchSubmittedPage,
})
